import React, { lazy, Suspense } from "react";
import { Switch, Route } from "react-router-dom";

import "./App.css";

import LinearProgress from "@material-ui/core/LinearProgress";
import TokenCopyView from "./essential/TokenCopyView";

// import GetInByEmail from "./essential/GetInByEmail";

const GetInByEmail = lazy(() => import("./essential/GetInByEmail"));
const GetInByPhone = lazy(() => import("./essential/GetInByPhone"));
const UserRegistration = lazy(() => import("./essential/UserRegistration"));

// import { TheLayout } from "./essential/index";
const TheLayout = lazy(() => import("./essential/TheLayout"));
const LandingPage = lazy(() => import("./essential/LandingPage"));
const IOSDesclaimer = lazy(() => import("./essential/IosDisclaimer"));
const AndroidDesclaimer = lazy(() => import("./essential/AndroidDisclaimer"));
// import { TheLayout } from "./essential";
// const ShowAllAttendanceOnMap = lazy(()=>import("./components/School/View/RouteView/Attendance/ShowAllAttendanceOnMap"))

function App() {
  // console.clear();
  // console.log(process.env.REACT_APP_url);
  // console.log(process.env.REACT_APP_port);
  return (
    <div className="App">
      <Suspense fallback={<LinearProgress />}>
        <Switch>
          <Route
            exact
            path="/loginByEmail"
            name="Login By Email"
            component={GetInByEmail}
          />
          <Route
            exact
            path="/loginByPhone"
            name="Login By Phone"
            component={GetInByPhone}
          />

          <Route
            exact
            path="/LandingPage"
            name="Landing Page"
            component={LandingPage}
          />

          <Route
            exact
            path="/UserRegistration"
            name="Registration page"
            component={UserRegistration}
          />
{/* <Route path="/student-locations" element={<ShowAllAttendanceOnMap />} /> */}
          <Route
            exact
            path="/IOS-disclaimer"
            name="Ios Disclaimer page"
            component={IOSDesclaimer}
          />

          <Route
            exact
            path="/Android-disclaimer"
            name="Android Disclaimer page"
            component={AndroidDesclaimer}
          />

          <Route
            exact
            path="/inspector/:any"
            name="inspector"
            component={TokenCopyView}
          />
          <Route path="/" name="Home" component={TheLayout} />
        </Switch>
      </Suspense>
    </div>
  );
}

export default App;
